/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAcUnitIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-ac-unit"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.65 18.85L8.75 20.75Q8.38 21.13 7.84 21.13Q7.3 21.13 6.9 20.75Q6.5 20.35 6.5 19.8Q6.5 19.25 6.9 18.85L10.65 15.1L10.65 13.35L8.95 13.35L5.13 17.13Q4.75 17.52 4.2 17.51Q3.65 17.5 3.25 17.1Q2.88 16.7 2.88 16.16Q2.88 15.63 3.27 15.22L5.2 13.35L2.9 13.35Q2.35 13.35 1.98 12.97Q1.6 12.6 1.6 12.03Q1.6 11.47 1.98 11.09Q2.35 10.7 2.92 10.7L5.2 10.7L3.25 8.78Q2.88 8.4 2.88 7.86Q2.88 7.33 3.25 6.92Q3.65 6.53 4.2 6.53Q4.75 6.53 5.15 6.92L8.95 10.7L10.65 10.7L10.65 8.9L6.88 5.15Q6.5 4.78 6.5 4.22Q6.5 3.67 6.9 3.27Q7.3 2.9 7.84 2.9Q8.38 2.9 8.78 3.3L10.65 5.15L10.65 2.92Q10.65 2.38 11.03 1.99Q11.4 1.6 11.97 1.6Q12.53 1.6 12.91 1.99Q13.3 2.38 13.3 2.92L13.3 5.15L15.22 3.27Q15.6 2.9 16.14 2.9Q16.68 2.9 17.07 3.27Q17.48 3.67 17.48 4.22Q17.48 4.78 17.07 5.15L13.3 8.9L13.3 10.7L15.05 10.7L18.85 6.9Q19.23 6.53 19.77 6.53Q20.32 6.53 20.73 6.92Q21.1 7.33 21.1 7.86Q21.1 8.4 20.7 8.8L18.8 10.7L21.07 10.7Q21.63 10.7 22.01 11.09Q22.4 11.47 22.4 12.03Q22.4 12.6 22.01 12.97Q21.63 13.35 21.07 13.35L18.8 13.35L20.7 15.25Q21.1 15.63 21.1 16.16Q21.1 16.7 20.73 17.1Q20.32 17.5 19.77 17.51Q19.23 17.52 18.82 17.13L15.05 13.35L13.3 13.35L13.3 15.1L17.07 18.88Q17.48 19.25 17.48 19.81Q17.48 20.38 17.07 20.75Q16.68 21.13 16.14 21.13Q15.6 21.13 15.22 20.75L13.3 18.85L13.3 21.1Q13.3 21.65 12.91 22.02Q12.53 22.4 11.97 22.4Q11.4 22.4 11.03 22.02Q10.65 21.65 10.65 21.07Z" fill={color} />
    </svg>
  );
}
